module.exports = __webpack_public_path__ + "static/media/066-germany.81829d59.svg";